import React, { useState } from "react";

export function CenterConfigModal({
  show,
  onClose,
  centerData,
  onSave,
  doctorList,
}) {
  const [formData, setFormData] = useState(centerData || {});

  const fieldDependencies = {
    header_margin: (value, prev) => ({
      header_bodyarea: value + 140,
    }),
    footer_margin: (value, prev) => ({
      footer_bodyarea: value + 140,
    }),
    header_bodyarea: (value, prev) => ({
      header_margin: value - 140,
    }),
    footer_bodyarea: (value, prev) => ({
      footer_margin: value - 140,
    }),
    default_priority_level: () => ({}),
    interval_time_gap: () => ({}),
    default_doctor_key: () => ({}),
    review_flag: () => ({}),
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    let changeValue = '';
    if(name==='review_flag'){
      changeValue = value;
    }
    else{
      changeValue = Number(value);
    }
    

    setFormData((prev) => {
      let updated = { ...prev, [name]: changeValue };

      if (fieldDependencies[name]) {
        updated = {
          ...updated,
          ...fieldDependencies[name](changeValue, prev),
        };
      }

      return updated;
    });
  };

  return (
    <div className="centered-modal" style={{zIndex:"21055"}}>
      <div className="modal-header pt-2">
          <span className="close" id="close-button" onClick={onClose}>&times;</span>
          <h6 className="mb-0"><i className="bi bi-person-circle"></i> Report Setting: {formData?.center_name}</h6>
      </div>
      <div className="modal-body">
        <div className="modal-row">
          <div className="modal-column">
            <label>
              Header Margin:
              <input
                type="number"
                name="header_margin"
                value={formData?.header_margin ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />
            </label>
          </div>
          <div className="modal-column">
            <label>
              Header Body Area:
              <input
                type="number"
                name="header_bodyarea"
                value={formData?.header_bodyarea ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={140}
              />
            </label>
          </div>
        </div>
        <div className="modal-row">
          <div className="modal-column">
            <label>
              Footer Margin:
              <input
                type="number"
                name="footer_margin"
                value={formData?.footer_margin ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />
            </label>
          </div>
          <div className="modal-column">
            <label>
              Footer Body Area:
              <input
                type="number"
                name="footer_bodyarea"
                value={formData?.footer_bodyarea ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={140}
              />
            </label>
          </div>
        </div>
        <div className="modal-row" style={{fontStyle:"italic"}}>Notes: Report Format 1 line equal to 20</div>

        <div className="modal-row">
          <div className="modal-column">
            <label>
              Interval Time Gap:
              <input
                type="number"
                name="interval_time_gap"
                value={formData?.interval_time_gap ?? ""}
                className="modal-input"
                onChange={handleChange}
                min={0}
              />
            </label>
          </div>
          <div className="modal-column">
            <label>
              Default Priority Level:
              <select
                className="modal-input"
                id="ddldefault_priority_level"
                name="default_priority_level"
                onChange={handleChange}
              >
                <option value="0"
                  selected={0 === formData?.default_priority_level}
                >None</option>
                <option value="1"
                  selected={1 === formData?.default_priority_level}
                >Low</option>
                <option value="2"
                  selected={2 === formData?.default_priority_level}
                >High</option>
              </select>

            </label>
          </div>
        </div>
        <div className="modal-row">
          <div className="modal-column">
            <label>
              Default Doctor:
              <select
                className="modal-input"
                id="ddlDoctorList"
                name="default_doctor_key"
                onChange={handleChange}
              >
                <option value="">Please Select Doctor</option>
                {doctorList.map((doctor, i) => (
                  <option
                    key={i}
                    value={doctor.doctor_key}
                    selected={doctor.doctor_key === formData.default_doctor_key}
                  >
                    {doctor.doctor_name}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <div className="modal-column">
            <label>Report Review:
              <select
                className="modal-input"
                id="ddlreview_flag"
                name="review_flag"
                onChange={handleChange}
              >
                <option value="N"
                  selected={"N" === formData?.review_flag}
                >No</option>
                <option value="Y"
                  selected={"Y" === formData?.review_flag}
                >Yes</option>
              </select>
            </label>
            
          </div>
        </div>
        
      </div>

      <div className="modal-actions">
        <div className="col-lg-4 col-4"><button type="button"
                className="btn btn-secondary btn-sm btn-block bi bi-save2-fill" id="btnConfigSave" onClick={() => onSave(formData)}> SAVE</button></div>
        <div className="col-lg-3 col-4"><button type="button"
                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnConfigClose" onClick={onClose}> CLOSE</button></div>
      </div>
    </div>
  );
}
